import React from 'react';
import { Modal, DatePicker, Spin, Table } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import StringHelper from '../../lib/StringHelper';

import CurrentRoleStore from '../../stores/CurrentRoleStore';

import AttendanceCalendar from '../share/AttendanceCalendar';

import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';

export default class TeacherAttendanceRercordIndexPage extends React.Component {
  constructor(props) {
    super(props);
    let date = new Date();
    let currentDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    const columns = [
      { title: '姓名', dataIndex: 'full_name' },
      { title: '到校时间', dataIndex: 'in_date' },
      { title: '离校时间', dataIndex: 'out_date' },
      { title: '中途离校', dataIndex: 'leave_halfway', render: (text, record) => <span className={record.leave_halfway ? "header-operation" : ""} onClick={this.teacherRecordDetail.bind(this, record)}>{record.leave_halfway ? '查看' : '-'}</span> },
    ]

    this.state = {
      semester: SharedTools.getCurrentSemester(),
      currentRole: CurrentRoleStore.getCurrentRole(),
      setAttendance: false,
      editAttendance: false,
      currentDate,
      visible: false,
      loading: false,
      absenceTeachers: [],
      abnormalTeachers: [],
      teacher_records: [],
      columns
    }

    this.onDateChange = this.onDateChange.bind(this)

  }

  componentWillReceiveProps(newProps) {

  }

  componentDidMount() {
    const schoolId = this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId
    this.setState({
      schoolId
    })

    let date = new Date();
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      school_id: schoolId
    }
    this.getTeacherAttendance(data)
  }

  getTeacherAttendance(data) {
    DataService.getSchoolTeacherAbsence(data).then(res => {
      this.setState({
        absenceTeachers: res
      })
    }, (error) => {
      this.setState({
        loading: false,
      })
    })

    DataService.getSchoolTeacherAbnormal(data).then(res => {
      let data = [];
      res.forEach(item => {
        if (item.person) {
          let in_date = this.toolRecordTime(item.in_date);
          let out_date = this.toolRecordTime(item.out_date)
          let in_date_status = item.is_absence ? '未到' : (in_date ? in_date : '未知')
          let out_date_status = item.is_absence ? '未到' : (out_date ? out_date : '未知')

          data.push({
            id: item.id,
            full_name: item.person.full_name,
            in_date: in_date_status,
            out_date: out_date_status,
            leave_halfway: item.leave_halfway
          })
        }
      });
      this.setState({
        abnormalTeachers: data
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  toolRecordTime(str) {
    let time;
    if (str) {
      time = str.split('T')[1].split('.')[0];
    }
    return time
  }

  onDateChange(day, dateString) {
    let date = new Date(dateString)
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      school_id: this.state.schoolId
    }
    this.setState({
      currentDate: dateString
    })
    this.getTeacherAttendance(data)
  }

  showModal(status) {
    this.setState({
      visible: status
    })
  }

  teacherRecordDetail(record) {
    DataService.getTeacherAttendanceRecords({ record_id: record.id }).then(res => {
      res.map((item) => {
        // let time = this.toolRecordTime(item.pass_date);
        item.pass_date = this.toolRecordTime(item.pass_date)
      })
      this.setState({
        teacher_records: res,
        visible: true
      })
    }, (error) => {
      this.setState({
        loading: false,
      })
    })
  }

  _teacherAttendanceModal() {
    let teacher_records = this.state.teacher_records;
    return (
      <Modal
        title="中途离校"
        visible={this.state.visible}
        onCancel={this.showModal.bind(this, false)}
        footer={null}
        wrapClassName="attendance-class-detail-modal"
      >
        <div className="attendance-teacher-detail-container">
          {teacher_records.map((record, index) => <div key={index} className="detail-box">{record.pass_in ? '进门' : '出门'} <span className="split-line">-</span> {record.pass_date}</div> )}
        </div>
      </Modal>
    )
  }

  render() {
    let { columns, abnormalTeachers, absenceTeachers, loading} = this.state;
    return (
      <div className="teacher-attendance-record-index-page attendance-table-container">
        <DatePicker onChange={this.onDateChange} locale={locale} allowClear={false} defaultValue={moment(this.state.currentDate, 'YYYY-MM-DD')} placeholder="" className="date-picker-container" />
        <Spin spinning={this.state.loading}>
          <div className="record-container">
            <div className="grade-attendance-info">未到老师<span className="info-point">{this.state.absenceTeachers.length}</span>人</div>
            <div className="classes-list">
              {absenceTeachers.map((teacher) => <div className="class-grid" key={teacher.id}>
                <div className="class-name">{teacher.full_name}</div>
              </div>)}
            </div>
          </div>
          <div className="attendance-table">
            <Table dataSource={abnormalTeachers} columns={columns} pagination={false} loading={loading} rowKey={record => record.id} />
          </div>
          {this._teacherAttendanceModal()}          
        </Spin>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/TeacherAttendanceRercordIndexPage.jsx